/*
 * @FilePath: /netHallOfficialAccounts/src/api/components.js
 */

import request from '@/utils/service';


/* 词语 */
export function getAllDict(id) {
  return request({
    url: `/sysDictListByCode/${id}`,
    method: 'get'
  })
}

/* 行政区域 */
export function selectRegionTree(parentRegionId) {
  return request({
    url: `/nethallRegion/tree/${parentRegionId}`,
    method: 'get',
  })
}

/* 附件上传 */
export function uploadPicture(data) {
  return request({
    url: '/client/file/batch/upload',
    method: 'post',
    data,
    hideloading: true
  })
}

/* 根据图片ID获取URL */
export function getPictureUrl(data) {
  return request({
    url: '/minioPicture/getPictureUrl',
    method: 'post',
    data
  })
}

/* 根据图片ID获取URL */
export function getPictureData(data) {
  return request({
    url: '/minioPicture/viewFiles',
    method: 'post',
    data,
  });
}
